module.exports = __webpack_public_path__ + "static/media/bold.b0ded0a1.svg";